module.exports = __webpack_public_path__ + "static/media/cookLogo_versao.9f4e41a0.png";